import Box from '@mui/material/Box';
import TextField from '@mui/material/TextField';
import * as Yup from 'yup';
import { Form, Formik, Field, ErrorMessage, useFormik } from 'formik';
import * as Icon from '@mui/icons-material/';
import { createBrowserHistory } from 'history';
import { IconButton } from '@mui/material';
import { Header, BoxButtons, Button } from '../../../Styles/ScreenStyle';
import { HeaderComponent } from '../../../../shared/components/HeaderComponent';
import { useEffect, useState, useCallback } from 'react';
import { useSelector } from 'react-redux';
import { useConfirmacao } from '../../../../hooks/useConfirmacao';
import { useParams } from 'react-router-dom';
import { NumericFormat } from 'react-number-format';
import FormaPagamentoController from '../../../../controllers/FormaPagamentoController';
import IntervaloParcelasController from '../../../../controllers/IntervaloParcelasController';
import { Column } from '../../../Components/Table/Types';
import { useRef } from 'react';
import ComponentTable from '../../../Components/Table/Index';
import { toast } from 'react-toastify';
import { useLocation } from 'react-router-dom';
import { InputSelect, Item } from '../../../../shared/components/InputSelect';
import TipoPagamentoController from '../../../../controllers/TipoPagamentoController';

interface Row {
  BtnExcluir?: JSX.Element;
  IntervaloParcelaId?: number;
  DescricaoParcela: number;
  InicioParcela: string;
  FimParcela: number;
  TaxaParcela: string;
  userIdParcela: number;
}

export default function FormaPagamentoCadastrar() {
  const ref = useRef<HTMLButtonElement>(null);
  const userId = useSelector((state: any) => state.Authentication.userId);
  const { confirmar, dialogoConfirmacao } = useConfirmacao();
  const history = createBrowserHistory();
  const [single, setSingle] = useState<any>({});
  const { id } = useParams()
  const FormaPagamentoId = id ? parseInt(id, 10) : null;
  const location = useLocation();
  const duploClick = location.state?.duploClick || false;

  const tableColumns: Column[] = [
    { id: 'BtnExcluir', label: '', width: 60, minWidth: 0 },
    { id: 'IntervaloParcelaId', label: 'Codigo', minWidth: 0 },
    { id: 'DescricaoParcela', label: 'Descricao', minWidth: 0 },
    { id: 'InicioParcela', label: 'Inicio', minWidth: 0 },
    { id: 'FimParcela', label: 'Fim', minWidth: 0 },
    { id: 'TaxaParcela', label: 'Taxa', minWidth: 0 },
    { id: 'userIdParcela', label: '', minWidth: 0, width: 0 },
  ];

  const [tableRows, setTableRows] = useState<Row[]>([]);
  const [tipoPagamentoOptions, setTipoPagamentoOptions] = useState<Item[]>([]);


  useEffect(() => {
    handleTipoPagamentoOptions();
  }, []);

  useEffect(() => {
    ref?.current?.click();
  }, []);

  useEffect(() => {
    if (FormaPagamentoId !== null && FormaPagamentoId !== undefined) {
      getSingle(FormaPagamentoId);
    }
  }, [FormaPagamentoId]);

  const getSingle = async (FormaPagamentoId: number) => {
    const Response =
      await FormaPagamentoController.ListarUnico(FormaPagamentoId);

    setSingle(Response.Data);

    if (Response.Data?.intervalo?.length > 0) {
      const DataRows: any = [];
      Response.Data.intervalo.map((item: any) => {
        DataRows.push({
          BtnExcluir: (
            <IconButton
              onClick={() =>
                confirmar(
                  'Excluir este intervalo de parcela? Esta ação não pode ser desfeita.',
                  () => handleDeleteItem(item.ipc_id)
                )
              }
              aria-label='delete'
              color='error'
              title='Excluir'
            >
              <Icon.Delete />
            </IconButton>
          ),
          IntervaloParcelaId: item.ipc_id,
          DescricaoParcela: item.ipc_descricao,
          InicioParcela: item.ipc_inicio,
          FimParcela: item.ipc_fim,
          TaxaParcela: item.ipc_taxa,
          //userIdParcela: userId //Validar com araujo
        });
      });

      setTableRows(DataRows);
    } else {
      setTableRows([]);
    }
  };

  const handleTipoPagamentoOptions = useCallback(async () => {
    const result = await TipoPagamentoController.Listar({
      Descricao: '',
      TipoPagamentoId: null,
    });
    if (result.StatusCode === 200) {
      setTipoPagamentoOptions(
        result.Data.map((item: any) => ({
          value: item.tpg_id,
          label: item.tpg_descricao,
        }))
      );
    }
  }, []);

  const handleSubmit = async (
    values: any,
    { setSubmitting, resetForm }: any
  ) => {
    if (FormaPagamentoId === null) {
      const RequestRows: any = [];
      tableRows.map((item: Row) => {
        RequestRows.push({
          IntervaloParcelaId: item.IntervaloParcelaId,
          DescricaoParcela: item.DescricaoParcela,
          InicioParcela: item.InicioParcela,
          FimParcela: item.FimParcela,
          TaxaParcela: item.TaxaParcela,
          userIdParcela: userId,
        });
      });

      const request = {
        UsuId: userId,
        Descricao: values.Descricao,
        TipoPagamentoId: values.TipoPagamentoId,
        TipoUtilizacao: values.TipoUtilizacao,
        TipoCartao: values.TipoCartao,
        TaxaMinima: values.TaxaMinima,
        TaxaTransAVista: values.TaxaTransAVista,
        QntdDiasRecebimento: values.QntdDiasRecebimento,
        json_intervaloparcelas: RequestRows,
      };

      const response = await FormaPagamentoController.Adicionar(request);

      if (response.StatusCode === 204) {
        toast('Forma de Pagamento incluído com sucesso!', {
          type: 'success',
        })
        resetForm();
        formikParcelas.setValues({
          TaxaParcela: '',
          DescricaoParcela: '',
          InicioParcela: '',
          FimParcela: ''
        });
        await history.back();
      } else {
        toast('Erro ao incluir Forma de Pagamento!', {
          type: 'error',
        })
      }
    } else {
      EditarContato(values, { setSubmitting, resetForm });
    }
    setSubmitting(false);
  };


  const handleDeleteItem = async (ipc_id: number) => {
    const request: any = { userIdParcela: userId, IntervaloParcelaId: ipc_id };
    const response = await IntervaloParcelasController.Excluir(request);

    if (response.StatusCode === 204) {
      toast('Intervalo de Parcela excluído com sucesso!', {
        type: 'success'
      })
      if (FormaPagamentoId) {
        getSingle(FormaPagamentoId);
      }
    } else {
      toast('Erro ao excluir o intervalo de parcela!', {
        type: 'error'
      })
    }
  };

  function handleParcelas(): void {
    const { DescricaoParcela, InicioParcela, FimParcela, TaxaParcela } =
      formikParcelas.values;

    if (
      DescricaoParcela === '' &&
      InicioParcela === '' &&
      FimParcela === '' &&
      TaxaParcela === ''
    ) {
      console.log('Todos os campos estão vazios.');
      return;
    }

    const data = {
      BtnExcluir: (
        <IconButton
          // @ts-ignore - .
          onClick={() => handleDeleteItem()}
          aria-label='delete'
          color='error'
          title='Excluir'
        >
          <Icon.Delete />
        </IconButton>
      ),
      IntervaloParcelaId: null,
      DescricaoParcela: DescricaoParcela,
      InicioParcela: InicioParcela,
      FimParcela: FimParcela,
      TaxaParcela: TaxaParcela,
      //userIdParcela: userId
    };

    // @ts-ignore - .
    const novoArray: Row[] = [...tableRows, data];

    setTableRows(novoArray);
  }

  const EditarContato = async (
    values: any,
    { setSubmitting }: any
  ) => {
    const RequestRows: any = [];
    tableRows.map((item: Row) => {
      RequestRows.push({
        IntervaloParcelaId: item.IntervaloParcelaId,
        DescricaoParcela: item.DescricaoParcela,
        InicioParcela: item.InicioParcela,
        FimParcela: item.FimParcela,
        TaxaParcela: item.TaxaParcela,
        userIdParcela: userId,
      });
    });

    const atualizaRequest = {
      UsuId: userId,
      Descricao: values.Descricao,
      TipoPagamentoId: values.TipoPagamentoId,
      TipoUtilizacao: values.TipoUtilizacao,
      TipoCartao: values.TipoCartao,
      TaxaMinima: values.TaxaMinima,
      TaxaTransAVista: values.TaxaTransAVista,
      QntdDiasRecebimento: values.QntdDiasRecebimento,
      json_intervaloparcelas: RequestRows,
    };

    const request = {
      FormaPagamentoId: FormaPagamentoId,
      ...atualizaRequest,
    };

    const response = await FormaPagamentoController.Atualizar(request);

    if (response.StatusCode === 204) {
      toast('Forma de Pagamento atualizado com sucesso!', {
        type: 'success',
      })
      if (FormaPagamentoId) {
        getSingle(FormaPagamentoId);
      }
    } else {
      toast('Erro ao atualizar Forma de Pagamento!', {
        type: 'error',
      })
    }

    setSubmitting(false);
  };

  const initialValues = {
    UsuId: userId,
    FormaPagamentoId: single?.formapagto?.fpg_id || '',
    Descricao: single?.formapagto?.fpg_descricao || '',
    TipoPagamentoId: single?.formapagto?.tpg_id || '',
    TipoUtilizacao: single?.formapagto?.fpg_tipo_utilizacao || '',
    TipoCartao: single?.formapagto?.fpg_tipo_cartao || '',
    TaxaMinima: single?.formapagto?.fpg_taxa_minima || '',
    TaxaTransAVista: single?.formapagto?.fpg_taxa_transacao_avista || '',
    QntdDiasRecebimento:
      single?.formapagto?.fpg_quantidade_dias_recebimento || '',

    DescricaoParcela: single?.intervalo?.ipc_descricao || '',
    InicioParcela: single?.intervalo?.ipc_inicio || '',
    FimParcela: single?.intervalo?.ipc_fim || '',
    TaxaParcela: single?.intervalo?.ipc_taxa || '',
  };

  const formikParcelas = useFormik({
    initialValues: {
      DescricaoParcela: single?.ipc_descricao || '',
      InicioParcela: single?.ipc_inicio || '',
      FimParcela: single?.ipc_fim || '',
      TaxaParcela: single?.ipc_taxa || '',
    },

    onSubmit: (values) => {
      console.log('Formulário 2 enviado:', values);
    },
  });

  const validationSchema = Yup.object().shape({
    Descricao: Yup.string()
      .required('Campo Obrigatorio!')
      .min(4, 'O Campo deve ter no minimo 4 caracteres'),
    TipoPagamentoId: Yup.string(),
    TipoUtilizacao: Yup.string(),
    TipoCartao: Yup.string(),
    TaxaMinima: Yup.string(),
    TaxaTransAVista: Yup.string(),
    QntdDiasRecebimento: Yup.string(),
    DescricaoParcela: Yup.string(),
    InicioParcela: Yup.string()
      .typeError('Por favor, isira um número válido'),
    FimParcela: Yup.string(),
    TaxaParcela: Yup.string(),
  });

  return (
    <Box
      sx={{
        '& .MuiTextField-root': { m: 1, width: '35ch' },
      }}
    >
      <div>
        <HeaderComponent text={'CADASTRO DE FORMA DE PAGAMENTO'} className={'mb-5'} />

        <Formik
          enableReinitialize={true}
          initialValues={initialValues}
          validationSchema={validationSchema}
          onSubmit={handleSubmit}
        >
          {({ errors, values, handleBlur, handleChange }) => (
            <Form>
              <div>
                <BoxButtons>
                  <Button
                    variant='contained'
                    onClick={() => history.back()}
                    color='warning'
                    startIcon={<Icon.ArrowBack />}
                  >
                    Voltar
                  </Button>
                  <Button
                    type={'submit'}
                    variant='contained'
                    color='success'
                    startIcon={<Icon.Save />}
                    disabled={duploClick}
                  >
                    Salvar
                  </Button>
                </BoxButtons>
                <fieldset disabled={duploClick}>
                  <Field
                    name='FormaPagamentoId'
                    as={TextField}
                    id='outlined-password-input'
                    label='Código'
                    type='number'
                    autoComplete='current-password'
                    InputProps={{ disabled: true }}
                  />
                  <Field
                    name='Descricao'
                    as={TextField}
                    label='Descrição'
                    type='text'
                    error={Boolean(errors?.Descricao)}
                    helperText={errors?.Descricao}
                  />
                  <Field
                    name='TipoUtilizacao'
                    as={TextField}
                    label='Utilização'
                    type='text'
                    error={Boolean(errors?.TipoUtilizacao)}
                    helperText={errors?.TipoUtilizacao}
                  />
                  <InputSelect
                    label='Tipo de Pagamento'
                    name='TipoPagamentoId'
                    size='small'
                    items={tipoPagamentoOptions}
                    className={'col-span-4'}
                    handleChange={handleChange}
                    value={values.TipoPagamentoId || ''}
                    helperText={errors.TipoPagamentoId as string}
                    error={Boolean(errors?.TipoPagamentoId)}
                    disabled={duploClick}
                  />
                  <Field
                    name='TipoCartao'
                    as={TextField}
                    label='Cartão'
                    type='text'
                    error={Boolean(errors?.TipoCartao)}
                    helperText={errors?.TipoCartao}
                  />
                  <Field
                    name='TaxaMinima'
                    as={TextField}
                    label='Taxa Mínima'
                    type='number'
                    error={Boolean(errors?.TaxaMinima)}
                    helperText={errors?.TaxaMinima}
                  />
                  <Field
                    name='TaxaTransAVista'
                    as={TextField}
                    label='Taxa de Transação à vista'
                    type='number'
                    error={Boolean(errors?.TaxaTransAVista)}
                    helperText={errors?.TaxaTransAVista}
                  />
                  <Field
                    name='QntdDiasRecebimento'
                    as={TextField}
                    label='Quantidade de Dias Para Recebimento'
                    type='text'
                    error={Boolean(errors?.QntdDiasRecebimento)}
                    helperText={errors?.QntdDiasRecebimento}
                  />
                </fieldset>
              </div>
              <p style={{ paddingBottom: 50 }}></p>
              <hr></hr>
              {/*<p style={{ paddingBottom: 50 }}></p>*/}
              <Header>INTERVALOS PARCELAS</Header>
              <div>
                <BoxButtons>
                  <Button
                    variant='contained'
                    onClick={() => handleParcelas()}
                    color='success'
                    startIcon={<Icon.Add />}
                    disabled={duploClick}
                  >
                    incluir
                  </Button>
                </BoxButtons>
                <fieldset disabled={duploClick}>
                  <Field
                    name='DescricaoParcela'
                    as={TextField}
                    label='Descrição'
                    type='text'
                    InputLabelProps={{ shrink: true }}
                    error={Boolean(errors?.DescricaoParcela)}
                    helperText={errors?.DescricaoParcela}
                    value={formikParcelas.values.DescricaoParcela}
                    onChange={(event: { target: { value: any } }) =>
                      formikParcelas.setFieldValue(
                        'DescricaoParcela',
                        event.target.value
                      )
                    }
                  />
                  <Field
                    name='InicioParcela'
                    as={TextField}
                    label='Inicio'
                    type='number'
                    InputLabelProps={{ shrink: true }}
                    error={Boolean(errors?.InicioParcela)}
                    helperText={errors?.InicioParcela}
                    value={formikParcelas.values.InicioParcela}
                    onChange={(event: { target: { value: any } }) =>
                      formikParcelas.setFieldValue(
                        'InicioParcela',
                        event.target.value
                      )
                    }
                  />
                  <Field
                    name='FimParcela'
                    as={TextField}
                    label='Fim'
                    type='number'
                    InputLabelProps={{ shrink: true }}
                    error={Boolean(errors?.FimParcela)}
                    helperText={errors?.FimParcela}
                    value={formikParcelas.values.FimParcela}
                    onChange={(event: { target: { value: any } }) =>
                      formikParcelas.setFieldValue(
                        'FimParcela',
                        event.target.value
                      )
                    }
                  />
                  <Field
                    name='TaxaParcela'
                    render={({ field }: { field: any }) => (
                      <NumericFormat
                        {...field}
                        customInput={TextField}
                        label='Taxa'
                        thousandSeparator='.'
                        decimalSeparator=','
                        prefix='% '
                        InputLabelProps={{ shrink: true }}
                        allowNegative={false}
                        decimalScale={2}
                        fixedDecimalScale={true}
                        allowedDecimalSeparators={[]}
                        error={Boolean(field.error)}
                        helperText={<ErrorMessage name='TaxaParcela' />}
                        onValueChange={(value) =>
                          formikParcelas.setFieldValue('TaxaParcela', value.value)
                        }
                      />
                    )}
                  />
                </fieldset>
              </div>
            </Form>
          )}
        </Formik>
      </div>
      <ComponentTable columns={tableColumns} rows={tableRows} />
      {dialogoConfirmacao}
    </Box>
  );
}
